module.exports = __webpack_public_path__ + "static/media/fenix-publinet.348a8c12.png";